import LayoutMain from '@Layouts/LayoutMain';
import QualityDepartment from '@Components/QualityDepartment';
import usePage from '@Queries/usePage';
import PageTopBar from '@Components/PageTopBar';
import Document from './elements/Document';
import Section from './elements/Section';
import Info from './elements/Info';
import Garanties from './elements/Garanties';
import ContactWithQualityDep from './elements/ContactWithQualityDep';
import ExchangeAndRefund from './elements/ExchangeAndRefund';
import Paragraphs from './elements/Paragraphs';
import Page from '@Components/Page';
import styles from './PageWarranty.module.css';

import type { PageWarrantyData } from './typings';
import type { FC } from 'react';

const PageWarranty: FC = () => {
  const { data: page } = usePage<PageWarrantyData>();

  return (
    <LayoutMain>
      <Page>
        <PageTopBar
          title={page.meta.h1}
          breadcrumbs={page.breadcrumbs}
          navigation={page.pageMenu}
        />
        <div className={styles.page} data-testid='page-warranty'>
          <div className={styles.narrowContainer}>
            <Section>
              {page.cares?.length > 0 && (
                <Paragraphs className={styles.mainText}>{page.cares}</Paragraphs>
              )}

              <QualityDepartment schedule={page.contacts} oferta={page.oferta} />

              <Paragraphs>{page.description}</Paragraphs>

              {page.warrantyPeriodText && <Info content={page.warrantyPeriodText} />}

              {page.docs?.length > 0 && (
                <div className={styles.docs}>
                  {page.docs.map((document, index) => (
                    <Document document={document} key={index} />
                  ))}
                </div>
              )}
            </Section>

            <Garanties warranty={page.warranty} />
          </div>

          {page.feedback && <ContactWithQualityDep feedbackLink={page.feedbackLink} />}

          <div className={styles.narrowContainer}>
            <ExchangeAndRefund
              conditions={page.conditions}
              refund={page.refund}
              notice={page.refundNotice}
            />
          </div>
        </div>
      </Page>
    </LayoutMain>
  );
};

export default PageWarranty;
